/**
 * Shared presentational page title.
 *
 * The canonical site title: an INK (`#0A0A0A`) Space Grotesk `<h1>` with a short
 * green gradient rule below — the brand green is the precise accent, not the
 * text color (amber retreats to CTAs/flags). Both `PageHeaderRenderer` and
 * `DataRecordDetailRenderer` render through this component so every inner
 * page — authored or migrated — has an identical header. Keep this the single
 * source of truth for the title look.
 */
export function PageTitle({ title }: { title: string }) {
  return (
    <header className="mb-3 md:mb-4">
      <h1
        className="text-3xl font-bold tracking-tight text-[#0A0A0A] md:text-4xl"
        style={{ fontFamily: "var(--font-aleo)" }}
      >
        {title}
      </h1>
      <div className="mt-2.5 h-1 w-16 rounded-full bg-[#00B862]" aria-hidden="true" />
    </header>
  );
}
